import React from 'react';
import { Helmet } from 'react-helmet-async';

/*
  Reusable SEO component.
  Props:
    title: Page title (string)
    description: Meta description (string)
    canonical: Canonical URL (string)
    image: Social sharing image (absolute or %PUBLIC_URL%)
    noIndex: boolean to add noindex robots tag
    structuredData: object or array for JSON-LD
*/

const SEO = ({
  title = 'each otter – Peer-Learning für Schulen | EachOtter',
  description = 'each otter ist die Peer-Learning-App für Schulen: Schüler:innen finden an ihrer Schule, wer ihnen weiterhilft, und verabreden sich zum Lernen. Let\'s help each otter!',
  canonical = 'https://eachotter.de/',
  image = 'https://eachotter.de/og-image-v2.jpg',
  noIndex = false,
  structuredData = null
}) => {
  const ldJson = structuredData ? (Array.isArray(structuredData) ? structuredData : [structuredData]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="each otter – „Let’s help each otter!“ neben einer Profilkarte und einem Chat aus der App" />
      <meta property="og:site_name" content="EachOtter" />
      <meta property="og:locale" content="de_DE" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {ldJson.map((entry, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
